




























































import { Component, Prop, Vue } from "vue-property-decorator";
import ChoiceFactorInput from "@/components/choice-input/ChoiceFactorInput.vue";
import _ from "lodash";
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import { FactorGroup, ValueTypeDefinition } from "@/api/model/FactorResource";

@Component(
    {
        components: {ChoiceFactorInput, ConfirmationDialog}
    })
export default class ChoiceInputFormGrowingTable extends Vue {

    @Prop()
    tableFactorGroup!: FactorGroup;

    @Prop()
    factorResources!: { [id: string]: any }

    @Prop()
    choiceForm!: any;

    get headers() {
        let headers = this.tableFactorGroup.childrenIds
            .map(id => this.factorResources[id])
            .filter((tc: any) => tc.numWeightingDots > 0)
            .map((column: any) => {
                return {
                    text: column.name,
                    value: column.id,
                    width: this.getWidth(column.valueTypeDefinition),
                    sortable: false,
                    align: ''
                };
            });
        headers.unshift({
            text: " ",
            value: "actions",
            sortable: false,
            align: 'center',
            width: 32
        })
        return headers
    }

    get tableData() {
        let dataLengths = this.tableFactorGroup.childrenIds
            .map(id => this.factorResources[id])
            .map((tc: any) => tc.dataField)
            .map((df: string) => this.choiceForm[df])
            .filter((data: any) => data && Array.isArray(data))
            .map((data: any[]) => data.length)
        let maxDataLength = Math.max(0, ...dataLengths)

        this.tableFactorGroup.childrenIds
            .map(id => this.factorResources[id])
            .map((tc: any) => tc.dataField)
            .forEach((df: string) => {
                if (maxDataLength > 0 && this.choiceForm[df] == null) {
                    Vue.set(this.choiceForm, df, _.map(new Array(maxDataLength), (el) => {
                        return null
                    }));
                } else if (maxDataLength > 0 && this.choiceForm[df].length < maxDataLength) {
                    this.choiceForm[df].splice(this.choiceForm[df].length, 0, ..._.map(new Array(maxDataLength - this.choiceForm[df].length), () => {
                        return null
                    }))
                }
            });

        return _.map(new Array(maxDataLength), (el, i) => {
            return {
                index: i
            }
        });

    }

    private getWidth(valueTypeDefinition: ValueTypeDefinition) {
        if (!valueTypeDefinition) return 140;
        switch (valueTypeDefinition.valueType) {
            case 'TEXT':
                return 200;
            case 'FILE':
            case 'CATEGORICAL':
                return 160;
        }
        return 140;
    }

    private addRow() {
        this.tableFactorGroup.childrenIds
            .map(id => this.factorResources[id])
            .map((tc: any) => tc.dataField)
            .forEach((df: string) => {
                if (this.choiceForm[df] == null) {
                    Vue.set(this.choiceForm, df, [null]);
                } else {
                    this.choiceForm[df].splice(this.choiceForm[df].length, 0, null);
                }
            })
    }

    private deleteRow(index: number) {
        this.tableFactorGroup.childrenIds
            .map(id => this.factorResources[id])
            .map((tc: any) => tc.dataField)
            .forEach((df: string) => this.choiceForm[df].splice(index, 1));
    }

}
